import React, { useState } from 'react';
import { Filter } from './filter';

interface IFiltersProps {
  className?: string;
  filters: string[];
  activeFilter: string;
  onFilterChange: (filter: string) => void;
}
export default function Filters({
  className,
  filters,
  activeFilter: initialActiveFilter,
  onFilterChange,
}: IFiltersProps) {
  const [activeFilter, setActiveFilter] = useState(initialActiveFilter);

  const handleFilterChange = (filter: string) => {
    setActiveFilter(filter);
    onFilterChange(filter);
  };

  return (
    <div className={className}>
      {filters.map((filter, idx) => (
        <Filter
          key={idx}
          text={{ text: filter }}
          isActive={filter === activeFilter}
          onClick={() => handleFilterChange(filter)}
          notSwitchOffByClick
        />
      ))}
    </div>
  );
}
